import { render } from "./Pontuacao.vue?vue&type=template&id=4931fb2a&scoped=true"
import script from "./Pontuacao.vue?vue&type=script&lang=js"
export * from "./Pontuacao.vue?vue&type=script&lang=js"

import "./Pontuacao.vue?vue&type=style&index=0&id=4931fb2a&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4931fb2a"]])

export default __exports__